module.exports = __webpack_public_path__ + "static/media/p-logo-dominos.f38bdf36.svg";